import { addCommas } from "@domains/utils/numberMethods";
import { objectValidation } from "@domains/utils/validation";
export var AumInsuranceMapper = function (data) {
    var aumInsuranceEntity = {
        aumInsuranceList: [],
    };
    if (data && data.length > 0) {
        aumInsuranceEntity.aumInsuranceList = data.map(function (record) {
            var reqObj = {
                policyId: record.policyid,
                policyName: record.policyname,
                instrumentType: record.instrumenttype,
                policyDate: record.policydate,
                term: record.term,
                schedule: record.schedule,
                premiumAnnulaized: record.premiumannulaized,
                amountInvested: record.amountinvested,
                currentValuation: record.currentvaluation,
                nextdueDate: record.nextduedate,
                paymentMode: record.paymentmode,
                status: record.status,
                transactionDetails: getTransactionDetails(record.transactiondetails),
            };
            return reqObj;
        });
    }
    return aumInsuranceEntity;
};
var getTransactionDetails = function (data) {
    var aumInsuranceTransactionDetails = [];
    if (data && data.length > 0) {
        aumInsuranceTransactionDetails = data.map(function (record) {
            return objectValidation({
                policyId: record.policyid,
                transactionDate: record.transactiondate,
                transactionId: record.transactionid,
                transactionType: record.transactiontype,
                amount: addCommas(record.amount),
                status: record.status,
            });
        });
    }
    return aumInsuranceTransactionDetails;
};
